var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "level" }, [
        _c("div", { staticClass: "level-left" }, [
          _c("p", { staticClass: "label" }, [_vm._v(_vm._s(_vm.label))]),
          _vm.description
            ? _c("p", [_vm._v(_vm._s(_vm.description))])
            : _vm._e(),
        ]),
        _c("div", { staticClass: "level-right" }, [
          _c(
            "button",
            {
              staticClass: "button is-primary is-small",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.addFeature.apply(null, arguments)
                },
              },
            },
            [
              _c("dc-icon", { attrs: { icon: "plus" } }),
              _c("span", [_vm._v("Selling point")]),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "draggable",
        {
          attrs: {
            list: _vm.points,
            group: { draggable: ".key-feature", dragClass: ".fa-bars" },
          },
          on: { end: _vm.end },
        },
        _vm._l(_vm.points, function (_name, index) {
          return _c("div", { key: index, staticClass: "key-feature" }, [
            _c(
              "div",
              { staticClass: "dragging-text" },
              [
                _c("b-input", {
                  attrs: {
                    maxlength: 50,
                    "has-counter": true,
                    placeholder:
                      "Briefly describe a unique selling point of your facility",
                  },
                  on: { blur: _vm.myBlur },
                  model: {
                    value: _vm.points[index],
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.points,
                        index,
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "points[index]",
                  },
                }),
                _c("div", { staticClass: "controls" }, [
                  _c(
                    "span",
                    {
                      staticClass: "delete-item",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.removeFeature(index)
                        },
                      },
                    },
                    [_c("i", { staticClass: "fa fa-times fa-fw" })]
                  ),
                  _c("i", { staticClass: "fa fa-bars fa-fw dragger" }),
                ]),
              ],
              1
            ),
          ])
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }